module.exports = __webpack_public_path__ + "img/tu13.a149c9c1.png";